module.exports = __webpack_public_path__ + "static/media/Embroidered-Denim.c606d61d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/denim/Embroidered-Denim.jpg
// module id = 136
// module chunks = 0